<div
  class="utility-nav-container"
  [ngClass]="{ vertical: vertical, collapsed: vertical && isCollapsed }"
>
  @if (vertical) {
    <button
      class="collapse-button mb-0 mt-0 {{
        isCollapsed ? 'rotate' : 'pull-right me-2'
      }}"
      type="button"
      mat-icon-button
      [matTooltip]="isCollapsed ? 'Expand Menu' : 'Collapse Menu'"
      (click)="toggleVerticalCollapse()"
    >
      <mat-icon>chevron_left</mat-icon>
    </button>
  }

  @if (!rights?.includes('CarrierPortal')) {
    @if (rights?.includes('ToolsLandingPage')) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [matTooltip]="isCollapsed ? 'Home' : ''"
        (click)="nav('tools')"
      >
        <mat-icon>home</mat-icon>
        <span class="text-container">Home</span>
      </button>
    } @else {
      <button
        type="button"
        mat-button
        class="mt-0"
        [matTooltip]="isCollapsed ? 'Home' : ''"
        (click)="nav('unified')"
      >
        <mat-icon>home</mat-icon>
        <span class="text-container">Home</span>
      </button>
    }

    @if (
      homeOfficeUser &&
      links?.includes('bookManagement') &&
      this.rights?.includes('BookManagement')
    ) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'office-view' }"
        [matTooltip]="isCollapsed ? 'Office Reports' : ''"
        (click)="nav('book-management/office-view')"
      >
        <mat-icon>table_chart</mat-icon>
        <span class="text-container">Office View</span>
      </button>
    }

    @if (
      hasRepCodes &&
      links?.includes('bookManagement') &&
      this.rights?.includes('BookManagement') &&
      isProducer
    ) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'rep-reports' }"
        [matTooltip]="isCollapsed ? 'Reports' : ''"
        (click)="nav('book-management/rep-reports')"
      >
        <mat-icon>folder_shared</mat-icon>
        <span class="text-container">Rep View</span>
      </button>
    }

    @if (
      links?.includes('bookManagement') &&
      this.rights?.includes('BookManagement')
    ) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'pm' }"
        [matTooltip]="isCollapsed ? 'Book Management' : ''"
        (click)="nav('book-management')"
      >
        <mat-icon>menu_book</mat-icon>
        <span class="text-container">Book Management</span>
      </button>
    }

    @if (links?.includes('dash') && rights?.includes('NewDashboardTab')) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'rb' }"
        [matTooltip]="dashboardTooltip()"
        (click)="nav('dashboard')"
      >
        <mat-icon>dashboard</mat-icon>
        @if (rights?.includes('SE')) {
          <span class="text-container">Dashboard</span>
        } @else {
          <span class="text-container">Firm Overview</span>
        }
      </button>
    }

    @if (
      current === 'se' || (rights?.includes('SE') && current === 'reporting')
    ) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'search' }"
        [matTooltip]="isCollapsed ? 'Find Opportunities' : ''"
        (click)="nav('se/search')"
      >
        <mat-icon>search</mat-icon>
        <span class="text-container">Find Opportunities</span>
      </button>
    }

    @if (
      links?.includes('repBehavior') && rights?.includes('RepBehaviorPage')
    ) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'repBehavior' }"
        [matTooltip]="isCollapsed ? 'Rep Behavior' : ''"
        (click)="nav('/rep-behavior')"
      >
        <mat-icon>psychology</mat-icon>
        <span class="text-container">Rep Behavior</span>
      </button>
    }

    @if (links?.includes('caseExplorer') && rights?.includes('CaseExplorer')) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'caseExplorer' }"
        [matTooltip]="isCollapsed ? 'Case Explorer' : ''"
        (click)="nav('/case-explorer')"
      >
        <mat-icon>find_in_page</mat-icon>
        <span class="text-container">Case Explorer</span>
      </button>
    }

    @if (
      links?.includes('reporting') && rights?.includes('ReportingTabInMenu')
    ) {
      <button
        type="button"
        mat-button
        class="mt-0"
        [ngClass]="{ active: current === 'reporting' }"
        [matTooltip]="isCollapsed ? 'Reporting' : ''"
        (click)="nav('reporting')"
      >
        <mat-icon>assessment</mat-icon>
        <span class="text-container">Reporting</span>
      </button>
    }
  }

  @if (
    links?.includes('carrierPortal') &&
    (rights?.includes('CarrierPortal') ||
      rights?.includes('HomeOfficeCarrierPortal'))
  ) {
    <button
      type="button"
      mat-button
      class="mt-0"
      [ngClass]="{ active: current === 'carrier-portal' }"
      [matTooltip]="isCollapsed ? 'Carrier Portal' : ''"
      (click)="nav('carrier-portal')"
    >
      <mat-icon>sensor_window</mat-icon>
      <span class="text-container">Carrier Portal</span>
    </button>
  }

  @if (
    links?.includes('carrierPortal') &&
    rights?.includes('CarrierPortalPolicyDetails')
  ) {
    <button
      type="button"
      mat-button
      class="mt-0"
      [ngClass]="{ active: current === 'carrier-policy-details' }"
      [matTooltip]="isCollapsed ? 'Policy Details' : ''"
      (click)="nav('carrier-policy-details')"
    >
      <mat-icon>library_books</mat-icon>
      <span class="text-container">Policy Details</span>
    </button>
  }
</div>
